module.exports = __webpack_public_path__ + "img/image-2.0768f30b.png";